import { images } from "../images";

const menuItems = [
  // ...
  {
    title: "Dashboard",
    url: "/client-dashboard",
    icon: images.DashboardIcon,
    inactiveIcon: images.DashboardInactive,
    value: 4,
  },
  {
    title: "Minting",
    url: "/asset-list",
    icon: images.MintingIcon,
    inactiveIcon: images.MintingInactive,
    value: 5,
    submenu: [
      {
        title: "Assets",
        url: "asset-list",
        icon: images.SubmenuIcon,
        inactiveIcon: null,
        parentMenu: "Minting",
        value: 1,
      },
      {
        title: "Drops",
        url: "drop-list",
        icon: images.SubmenuIcon,
        inactiveIcon: null,
        parentMenu: "Minting",
        value: 2,
      },
    ],
  },

  {
    title: "Theme",
    url: "/branding",
    icon: images.MonitorIcon,
    inactiveIcon: images.ThemeInactive,
    value: 6,
    submenu: [
      {
        title: "Branding",
        url: "/branding",
        icon: images.SubmenuIcon,
        inactiveIcon: null,
        parentMenu: "Theme",
        value: 1,
      },
      {
        title: "Preferences",
        url: "/preferences",
        icon: images.SubmenuIcon,
        inactiveIcon: null,
        parentMenu: "Theme",
        value: 2,
      },
    ],
  },
  {
    title: "Reporting",
    url: "/tx-reporting",
    icon: images.ReportingIcon,
    inactiveIcon: images.ReportingInactive,
    value: 7,
    submenu: [
      {
        title: "Transaction History",
        url: "/tx-reporting",
        icon: images.SubmenuIcon,
        inactiveIcon: null,
        parentMenu: "Reporting",
        value: 1,
      },
      {
        title: "Airdrop ",
        url: "/airdrop",
        icon: images.SubmenuIcon,
        inactiveIcon: null,
        parentMenu: "Reporting",
        value: 2,
      },
    ],
  },
  // {
  //   title: "Whitelist",
  //   url: "/whitelist",
  //   icon: images.WhitelistIcon,
  //   inactiveIcon: images.WhitelistInactive,
  //   value: 8,
  // },

  // {
  // 	title: "Configuration",
  // 	url: "/add-royalty",
  // 	icon: images.ConfigurationMenuIcon,
  // 	inactiveIcon: images.ContributorMenuInactive ,
  // 	value: 8,
  // 	submenu: [

  // 		{
  // 			title: "Royalty",
  // 			url: "/add-royalty",
  // 			icon: images.RoyalityMenuIcon,
  // 			inactiveIcon: images.RoyalityMenuInactive,
  // 			parentMenu: "Configuration",
  // 			value:1,
  // 		},
  // 		// {
  // 		//  	title: "Contributor",
  // 		//  	url: "/add-contributor",
  // 		//  	icon: images.ContributorMenuIcon,
  // 		//  	inactiveIcon:images.ContributorMenuInactive,
  // 		//  	parentMenu: "Configuration",
  // 		// 	value:2,
  // 		//  },
  // 	],
  // },
  {
    title: "Configuration",
    url: "/configuration",
    icon: images.Configuration,
    inactiveIcon: images.ConfigurationInactive,
    value: 10,
    submenu: [
      {
        title: "Domain",
        url: "/configuration",
        icon: images.SubmenuIcon,
        inactiveIcon: null,
        parentMenu: "Configuration",
        value: 1,
      },
    ],
  },

  {
    title: "Settings",
    url: "/client-change-password",
    icon: images.SettingIcon,
    inactiveIcon: images.SettingInactive,
    value: 9,
    submenu: [
      {
        title: "Change Password",
        url: "/client-change-password",
        icon: images.SubmenuIcon,
        inactiveIcon: null,
        parentMenu: "Settings",
        value: 1,
      },
      {
        title: "Edit Profile",
        url: "/onboarding",
        icon: images.SubmenuIcon,
        inactiveIcon: null,
        parentMenu: "Settings",
        value: 2,
      },
    ],
  },
  // {
  // 	title: "Logout",
  // 	url: "/login",
  // 	icon: images.LogoutIcon,
  // },

  // ...
];
const menuItemsAdmin = [
  {
    title: "Client Management",
    url: "/dashboard",
    icon: images.ClientSettingIcon,
    inactiveIcon: images.ClientDashboardInactive,
    value: 0,
  },
  {
    title: "Category",
    url: "/category",
    icon: images.CategoryIcon,
    inactiveIcon: images.CategoryInactive,
    value: 1,
  },
  {
    title: "Arweave Reporting",
    url: "/arweave-reporting",
    icon: images.ArweaveReportingIcon,
    inactiveIcon: images.ArweaveReportingInactive,
    value: 2,
  },
  {
    title: "Packages",
    url: "/choose-package",
    icon: images.MenuIconPackages,
    inactiveIcon: images.PackageMenuInactive,
    value: 3,
  },
];

export { menuItems, menuItemsAdmin };
